module KendoWidgets
{
	export class TextBoxEvent
	{
		sender: KendoWidgets.TextBox;
	}

	export class TextBoxKeyPressEvent extends TextBoxEvent
	{
		key: string;
		keyCode: number;
		shiftKeyPressed: boolean;
		altKeyPressed: boolean;
		ctrlKeyPressed: boolean;
		enterKeyPressed: boolean;
		backSpaceKeyPressed: boolean;
		tabKeyPressed: boolean;
		preventDefault: Function;
	}

	export class TextBoxOptions
	{
		width?: string | number;
		height?: string | number;
		placeholder?: string;
		textMode?: KendoWidgets.TextModeEnum;
		inputMode?: KendoWidgets.InputModeEnum;
		enabled?: boolean;
		readOnly?: boolean;
		defaultButtonId?: string;

		label?: string;
		labelPosition?: LabelPositionEnum;
		labelClass?: string;
		labelWidth?: number;
		rowsForHeight?: number;
		maxLength?: number;
		textAlign?: TextAlignEnum;
		css?: string;
		wrapper?: string | JQuery | Element;

		onBlur?(e: KendoWidgets.TextBoxEvent): void;
		onFocus?(e: KendoWidgets.TextBoxEvent): void;
		onKeyPress?(e: KendoWidgets.TextBoxKeyPressEvent): void;
		onKeyUp?(e: KendoWidgets.TextBoxKeyPressEvent): void;
	}

	export class TextBox extends kendo.ui.Widget implements KendoWidget
	{
		private _textareaElement: HTMLTextAreaElement;
		private _isOnError: boolean;
		private _isEnabled: boolean;
		private _firstLoad: boolean;

		public controlType(): ControlTypeEnum { return ControlTypeEnum.TextBox; }

		constructor(element: Element, options?: KendoWidgets.TextBoxOptions)
		{
			if (options == null)
				options = new KendoWidgets.TextBoxOptions();

			if (options.width == null) options.width = 190;
			if (options.placeholder == null) options.placeholder = "";
			if (options.textMode == null) options.textMode = KendoWidgets.TextModeEnum.Normal;
			if (options.enabled == null) options.enabled = true;
			if (options.readOnly == null) options.readOnly = false;
			if (options.rowsForHeight == null) options.rowsForHeight = 2;
			if (options.textAlign == null) options.textAlign = TextAlignEnum.Left;
			if (options.inputMode == null) options.inputMode = InputModeEnum.Default;

			//#region Width & Height
			if (typeof (options.width) == "number")
				options.width = options.width + "px";
			(element as HTMLElement).style.cssText += "width: " + options.width;

			if (typeof (options.height) == "number")
				options.height = options.height + "px";
			(element as HTMLElement).style.cssText += "height: " + options.height;
			//#endregion

			//#region Placeholder
			(element as HTMLInputElement).placeholder = options.placeholder;
			//#endregion

			(element as HTMLElement).classList.add("k-textbox");
			super(element, options);
			let that = this;

			//#region Label
			let label = document.createElement("label");
			if (options.label != null && !this._firstLoad)
			{
				this._firstLoad = true;

				let divContainer = document.createElement("div");
				$(element).wrap(divContainer);

				$("#" + element.id + "Label").remove();
				label.id = element.id + "Label";
				$(label).kendoLabel(
					{
						text: options.label,
						color: KendoWidgets.ColorEnum.BlueVettore,
						class: options.labelClass,
						height: 19,
						fontSize: 14,
						width: (options.labelWidth != null) ? options.labelWidth : "auto"
					});

				//#region Label position
				if (options.labelPosition == null) options.labelPosition = LabelPositionEnum.Top;
				switch (options.labelPosition)
				{
					case LabelPositionEnum.Top:
						{
							$(label).addClass("k-label-top");
							element.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.insertBefore(label, element.parentElement!.firstChild);

							(element as HTMLElement).style.cssText += "width: 100%";
						}
						break;
					case LabelPositionEnum.Left:
						{
							$(label).addClass("k-label-left");
							element.parentElement!.insertBefore(label, element.parentElement!.firstChild);
							label.style.cssText += "margin-right: 5px";

							window.setTimeout(() => (element as HTMLElement).style.cssText += "width: Calc(100% - " + ($(label).width() + 6) + "px)");
						}
						break;
					case LabelPositionEnum.Right:
						{
							$(label).addClass("k-label-right");
							element.parentElement!.append(label);
							label.style.cssText += "margin-left: 5px";

							(element as HTMLElement).style.cssText += "width: Calc(100% - " + (label.clientWidth + 6) + "px)";
						}
						break;
					case LabelPositionEnum.Bottom:
						{
							$(label).addClass("k-label-bottom");
							element.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.append(label);

							(element as HTMLElement).style.cssText += "width: 100%";
						}
						break;
				}
				//#endregion

				(element.parentElement! as HTMLElement).style.cssText += "display: inline-block; width: " + options.width;
				$(element).parent().attr("id", element.id + "Parent");
				$(element).parent().addClass("controlParent");
			}
			//#endregion

			//#region Text mode
			switch (options.textMode)
			{
				case KendoWidgets.TextModeEnum.Normal:
					{
						$(element).attr('type', 'text');

						if (options.maxLength != null)
							$(element).attr("maxlength", options.maxLength);
					}
					break;
				case KendoWidgets.TextModeEnum.MultiLine:
					{
						let textArea = document.createElement("textarea");
						textArea.id = element.id;

						if (typeof (options.height) == "number")
							options.height = options.height + "px";
						(textArea as HTMLElement).style.cssText += "height: " + options.height;

						//#region Rows for height
						if (options.height == null)
							(textArea as HTMLElement).style.cssText += "height: " + (38 + (20 * (options.rowsForHeight - 1))) + "px";
						//#endregion

						this._textareaElement = textArea;
						if (options.maxLength != null)
							$(textArea).attr("maxlength", options.maxLength);

						if (typeof (options.width) == "number")
							options.width = options.width + "px";

						// CSS
						(textArea as HTMLElement).style.cssText += "-webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box; width: " + options.width;
						(textArea as HTMLElement).style.cssText += "border-radius: 4px; border-color: rgba(33, 37, 41, 0.125); font-size: 16px; color: #000; padding: 5px; padding-left: 10px; padding-right: 10px; resize: none;";

						$(element).after(textArea);
						$(element).hide();

						//#region Label position
						if (options.label != null)
						{
							label.style.cssText += "float: left";
							switch (options.labelPosition)
							{
								case LabelPositionEnum.Top: (textArea as HTMLElement).style.cssText += "width: 100%"; break;
								case LabelPositionEnum.Left: (textArea as HTMLElement).style.cssText += "width: Calc(100% - " + ($(label).width() + 6) + "px)"; break;
								case LabelPositionEnum.Right: (textArea as HTMLElement).style.cssText += "width: Calc(100% - " + ($(label).width() + 6) + "px)"; break;
								case LabelPositionEnum.Bottom: (textArea as HTMLElement).style.cssText += "width: 100%"; break;
							}
						}
						//#endregion

						//#region Placeholder
						textArea.placeholder = options.placeholder;
						//#endregion
					}
					break;
				case KendoWidgets.TextModeEnum.Password:
					{
						$(element).attr('type', 'password');

						if (options.maxLength != null)
							$(element).attr("maxlength", options.maxLength);
					}
					break;
			}
			//#endregion

			//#region Enabled
			if (options.textMode == KendoWidgets.TextModeEnum.MultiLine)
				this._textareaElement.disabled = !options.enabled;
			else
				(element as HTMLInputElement).disabled = !options.enabled;

			this._isEnabled = options.enabled;

			if (options.readOnly || !options.enabled)
			{
				if (options.textMode == KendoWidgets.TextModeEnum.MultiLine)
					$(this._textareaElement).attr("tabIndex", "-1");
				else
					$(element).attr("tabIndex", "-1");
			}
			//#endregion

			let realItemElement: HTMLInputElement | HTMLTextAreaElement
			if (options.textMode == KendoWidgets.TextModeEnum.MultiLine)
				realItemElement = this._textareaElement
			else
				realItemElement = element as HTMLInputElement;

			//#region Events

			//#region OnBlur
			let onBlurUserOverride = options.onBlur;
			$(realItemElement).blur((e) =>
			{
				let event = new TextBoxEvent();
				event.sender = that;

				if (onBlurUserOverride != null)
					onBlurUserOverride(event);
			});
			//#endregion

			//#region OnFocus
			let onFocusUserOverride = options.onFocus;
			$(realItemElement).focusin((e) =>
			{
				let event = new TextBoxEvent();
				event.sender = that;

				if (onFocusUserOverride != null)
					onFocusUserOverride(event);
			});
			//#endregion

			//#region KeyPress
			let onKeyPressUserOverride = options.onKeyPress;
			$(realItemElement).keypress((e) =>
			{
				let event = new TextBoxKeyPressEvent();
				event.sender = that;
				event.key = e.key;
				event.keyCode = e.keyCode;
				event.shiftKeyPressed = e.shiftKey;
				event.altKeyPressed = e.altKey;
				event.ctrlKeyPressed = e.ctrlKey;
				event.enterKeyPressed = e.keyCode == 13;
				event.preventDefault = e.preventDefault;

				let defaultButtonId = options!.defaultButtonId;
				if (defaultButtonId != null && defaultButtonId != "" && event.enterKeyPressed)
				{
					if (defaultButtonId.startsWith("#"))
						$(defaultButtonId).click();
					else
						$("#" + defaultButtonId).click();
				}

				if (onKeyPressUserOverride != null)
					return onKeyPressUserOverride(event);
			});
			//#endregion	

			//#region KeyUp
			let onKeyUpUserOverride = options.onKeyUp;
			$(realItemElement).keyup((e) =>
			{
				//#region Input mode
				if (options!.inputMode == InputModeEnum.Capitalize)
				{
					let value = that.value();
					let firstChar = value[0];
					if (firstChar != null && firstChar != firstChar.toUpperCase())
						that.value(firstChar.toUpperCase() + value.substr(1));
				}
				else if (options!.inputMode == InputModeEnum.Uppercase)
				{
					let value = that.value();
					that.value(value.toUpperCase());
				}
				else if (options!.inputMode == InputModeEnum.Lowercase)
				{
					let value = that.value();
					that.value(value.toLowerCase());
				}
				//#endregion

				let event = new TextBoxKeyPressEvent();
				event.sender = that;
				event.key = e.key;
				event.keyCode = e.keyCode;
				event.shiftKeyPressed = e.shiftKey;
				event.altKeyPressed = e.altKey;
				event.ctrlKeyPressed = e.ctrlKey;
				event.enterKeyPressed = e.keyCode == 13;
				event.backSpaceKeyPressed = e.keyCode == 8;
				event.tabKeyPressed = e.keyCode == 9;
				event.preventDefault = e.preventDefault;

				let defaultButtonId = options!.defaultButtonId;
				if (defaultButtonId != null && defaultButtonId != "" && event.enterKeyPressed)
				{
					if (defaultButtonId.startsWith("#"))
						$(defaultButtonId).click();
					else
						$("#" + defaultButtonId).click();
				}

				if (onKeyUpUserOverride != null)
					onKeyUpUserOverride(event);
			});
			//#endregion

			//#endregion

			//#region Read Only
			if (options.readOnly)
				$(realItemElement).attr("readonly", "readonly");
			//#endregion

			//#region Text align
			switch (options.textAlign)
			{
				case TextAlignEnum.Left: $(realItemElement).css("text-align", "left"); break;
				case TextAlignEnum.Center: realItemElement.style.cssText += "text-align: center; text-indent: 0px;"; break;
				case TextAlignEnum.Right: $(realItemElement).css("text-align", "right"); break;
			}
			//#endregion

			//#region CSS
			if (options.css != null)
			{
				if (options.label != null)
					(realItemElement as HTMLElement).parentElement!.style.cssText += options.css;
				else
					(realItemElement as HTMLElement).style.cssText += options.css;
			}
			//#endregion

			//#region Wrapper
			if (options.wrapper != null)
				window.setTimeout(() => this.element.parent().wrap(options!.wrapper!));
			//#endregion
		}

		clear()
		{
			this.value("");
		}

		isEmpty()
		{
			return (this.value() == "");
		}

		focus()
		{
			if ((this.options as KendoWidgets.TextBoxOptions).textMode == KendoWidgets.TextModeEnum.MultiLine)
				return $(this._textareaElement).focus();
			else
				return this.element.focus();
		}

		//#region Caret
		caretPosition()
		{
			if ((this.options as KendoWidgets.TextBoxOptions).textMode == KendoWidgets.TextModeEnum.MultiLine)
				return this._textareaElement.selectionStart;
			else
				return (this.element[0] as HTMLInputElement).selectionStart!;
		}

		insertTextAtCursor(text: string)
		{
			if ((this.options as KendoWidgets.TextBoxOptions).textMode == KendoWidgets.TextModeEnum.MultiLine)
			{
				let element = this._textareaElement;
				this.value(element.value.substring(0, this.caretPosition())
					+ text
					+ element.value.substring(element.selectionEnd, element.value.length));

				element.selectionStart = this.caretPosition() + text.length;
				element.selectionEnd = this.caretPosition() + text.length;
			}
			else
			{
				let element = (this.element[0] as HTMLInputElement);
				this.value(element.value.substring(0, this.caretPosition())
					+ text
					+ element.value.substring(element.selectionEnd!, element.value.length));

				element.selectionStart = this.caretPosition() + text.length;
				element.selectionEnd = this.caretPosition() + text.length;
			}
		}

		insertTextAtPosition(text: string, position: number)
		{
			if ((this.options as KendoWidgets.TextBoxOptions).textMode == KendoWidgets.TextModeEnum.MultiLine)
			{
				let element = this._textareaElement;
				this.value(element.value.substring(0, position)
					+ text
					+ element.value.substring(element.selectionEnd, element.value.length));

				element.selectionStart = position + text.length;
				element.selectionEnd = position + text.length;
			}
			else
			{
				let element = (this.element[0] as HTMLInputElement);
				this.value(element.value.substring(0, position)
					+ text
					+ element.value.substring(element.selectionEnd!, element.value.length));

				element.selectionStart = position + text.length;
				element.selectionEnd = position + text.length;
			}
		}
		//#endregion

		value(text?: string)
		{
			if (text != null)
			{
				//#region Input mode
				if (text[0] != null && (this.options as KendoWidgets.TextBoxOptions).inputMode == KendoWidgets.InputModeEnum.Capitalize)
					text = text[0].toUpperCase() + text.substr(1);
				else if ((this.options as KendoWidgets.TextBoxOptions).inputMode == KendoWidgets.InputModeEnum.Uppercase)
					text = text.toUpperCase();
				else if ((this.options as KendoWidgets.TextBoxOptions).inputMode == KendoWidgets.InputModeEnum.Lowercase)
					text = text.toLowerCase();
				//#endregion

				if ((this.options as KendoWidgets.TextBoxOptions).textMode == KendoWidgets.TextModeEnum.MultiLine)
					this._textareaElement.value = text;
				else
					(this.element[0] as HTMLInputElement).value = text;
			}

			if ((this.options as KendoWidgets.TextBoxOptions).textMode == KendoWidgets.TextModeEnum.MultiLine)
				return this._textareaElement.value;
			else
				return (this.element[0] as HTMLInputElement).value;
		}

		placeholder(text?: string)
		{
			if (text != null)
			{
				if ((this.options as KendoWidgets.TextBoxOptions).textMode == KendoWidgets.TextModeEnum.MultiLine)
					this._textareaElement.placeholder = text;
				else
					(this.element[0] as HTMLInputElement).placeholder = text;
			}

			if ((this.options as KendoWidgets.TextBoxOptions).textMode == KendoWidgets.TextModeEnum.MultiLine)
				return this._textareaElement.placeholder;
			else
				return (this.element[0] as HTMLInputElement).placeholder;
		}

		enabled(value?: boolean)
		{
			if (value != null)
			{
				if (this.options.textMode == KendoWidgets.TextModeEnum.MultiLine)
					this._textareaElement.disabled = !value;
				else
					(this.element[0] as HTMLInputElement).disabled = !value;

				this._isEnabled = value;
			}

			return this._isEnabled;
		}

		errorHighlight(error?: boolean)
		{
			if (error != null)
			{
				this._isOnError = error;

				if (error)
					this.element[0].style.cssText += "border: solid 1px red";
				else
					this.element[0].style.cssText += "border: solid 1px #CCC";
			}

			return (this._isOnError == null) ? false : this._isOnError;
		}

		labelText(text?: string)
		{
			if (text != null)
				$("#" + this.element.attr("id") + "Label")[0].textContent = text;

			return $("#" + this.element.attr("id") + "Label")[0].innerHTML;
		}

		//#region Visible
		visible(visibleStatus?: boolean)
		{
			if (visibleStatus != null)
			{
				if (visibleStatus)
				{
					if (this.options.label != null)
					{
						if (this.options.textMode == KendoWidgets.TextModeEnum.MultiLine) $(this._textareaElement).parent().show();
						else this.element.parent().show();
					}
					else
					{
						if (this.options.textMode == KendoWidgets.TextModeEnum.MultiLine) $(this._textareaElement).show();
						else this.element.show();
					}
				}
				else
				{
					if (this.options.label != null)
					{
						if (this.options.textMode == KendoWidgets.TextModeEnum.MultiLine) $(this._textareaElement).parent().hide();
						else this.element.parent().hide();
					}
					else
					{
						if (this.options.textMode == KendoWidgets.TextModeEnum.MultiLine) $(this._textareaElement).hide();
						else this.element.hide();
					}
				}
			}

			if (this.options.label != null)
			{
				if (this.options.textMode == KendoWidgets.TextModeEnum.MultiLine) return $(this._textareaElement).parent().is(":visible");
				else return this.element.parent().is(":visible");
			}
			else
			{
				if (this.options.textMode == KendoWidgets.TextModeEnum.MultiLine) return $(this._textareaElement).is(":visible");
				else return this.element.is(":visible");
			}
		}

		show()
		{
			this.visible(true);
		}

		hide()
		{
			this.visible(false);
		}
		//#endregion

		appendTo(element: string | HTMLElement | JQuery)
		{
			if (this.options.label != null)
			{
				if (this.options.textMode == KendoWidgets.TextModeEnum.MultiLine) $(this._textareaElement).parent().appendTo(element);
				else this.element.parent().appendTo(element);
			}
			else
			{
				if (this.options.textMode == KendoWidgets.TextModeEnum.MultiLine) $(this._textareaElement).appendTo(element);
				else this.element.appendTo(element);
			}
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			if (this.options.label != null)
			{
				if (this.options.textMode == KendoWidgets.TextModeEnum.MultiLine) $(this._textareaElement).parent().prependTo(element);
				else this.element.parent().prependTo(element);
			}
			else
			{
				if (this.options.textMode == KendoWidgets.TextModeEnum.MultiLine) $(this._textareaElement).prependTo(element);
				else this.element.prependTo(element);
			}
		}
	}

	export enum TextModeEnum
	{
		Normal,
		MultiLine,
		Password
	}

	export enum InputModeEnum
	{
		Capitalize,
		Uppercase,
		Lowercase,
		Default
	}

	TextBox.fn = TextBox.prototype;
	TextBox.fn.options = $.extend(true, {}, kendo.ui.Widget.fn.options);
	TextBox.fn.options.name = "TextBox";
	kendo.ui.plugin(TextBox);
}

interface JQuery
{
	kendoTextBox(options?: KendoWidgets.TextBoxOptions): JQuery;
	data(key: "kendoTextBox"): KendoWidgets.TextBox;
}